import React, { createContext, useState, useContext, useEffect } from 'react';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check if user is logged in on mount
  useEffect(() => {
    const storedToken = localStorage.getItem('auth_token');
    const storedUser = localStorage.getItem('user');

    if (storedToken && storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        const cleanToken = storedToken.replace(/\r?\n/g, '').trim();
        setUser(userData);
        setToken(cleanToken);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Error restoring auth:', error);
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const login = (userData, authToken) => {
    const cleanToken = authToken?.replace(/\r?\n/g, '').trim();
    setUser(userData);
    setToken(cleanToken);
    setIsAuthenticated(true);
    
    // Store in localStorage
    localStorage.setItem('auth_token', cleanToken);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    setIsAuthenticated(false);
    
    // Remove from localStorage
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
  };

  const hasRole = (role) => {
    if (!user || !user.roles) return false;
    if (Array.isArray(role)) {
      return role.some(r => user.roles.includes(r));
    }
    return user.roles.includes(role);
  };

  const isAdmin = () => user?.roles?.includes('ADMIN') || false;
  const isHR = () => user?.roles?.includes('HR') || user?.roles?.includes('ADMIN') || false;
  const isRecruiter = () => user?.roles?.includes('RECRUITER') || user?.roles?.includes('ADMIN') || false;

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated,
        token,
        loading,
        login,
        logout,
        setUser,
        hasRole,
        isAdmin,
        isHR,
        isRecruiter
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
